import React from 'react';
import PropTypes from 'prop-types';

import { InputField, Field } from '../../Form';
import ActionButtons from 'components/ActionButtons';

const FullReportRequestForm = ({ formProps }) => (
  <form autoComplete="off" onSubmit={formProps.handleSubmit}>
    <div className="tw-grid tw-gap-4 sm:tw-grid-cols-2">
      <Field component={InputField} label="Your Name" name="requesterName" />

      <Field component={InputField} label="Role" name="requesterRole" />

      <Field component={InputField} label="Work Email" name="requesterEmail" />

      <Field component={InputField} label="Company" name="requesterCompanyName" />

      <Field component={InputField} label="LinkedIn" name="requesterLinkedin" />
    </div>
    <ActionButtons primaryActionText="Request the full report" />
  </form>
);

FullReportRequestForm.propTypes = {
  formProps: PropTypes.object,
};

export default FullReportRequestForm;
